import React from "react";

function Header() {
  return (
    <header>
      <div className="overlay"></div>
          <div className="text">
            <div className="wrapper">
              <div id="L" className="letter">R</div>
              <div className="shadow">R</div>
            </div>
            <div className="wrapper">
              <div id="I" className="letter">E</div>
              <div className="shadow">E</div>
            </div>
            <div className="wrapper">
              <div id="G" className="letter">P</div>
              <div className="shadow">P</div>
            </div>
            <div className="wrapper">
              <div id="H" className="letter">T</div>
              <div className="shadow">T</div>
            </div>
            <div className="wrapper">
              <div id="T" className="letter">R</div>
              <div className="shadow">R</div>
            </div>
            <div className="wrapper">
              <div id="N" className="letter">A</div>
              <div className="shadow">A</div>
            </div>
            <div className="wrapper">
              <div id="E" className="letter">C</div>
              <div className="shadow">C</div>
            </div>
            <div className="wrapper">
              <div id="S" className="letter">K</div>
              <div className="shadow">K</div>
            </div>
      </div>
    </header>
  );
}

export default Header;
